import { WprBaseViewMultiModeInfo } from '../../../wpr-framework/mode/WprBaseViewMultiMode';
import { PlanComponentView } from '../PlanComponentView';
import { WprMultiMode } from '../../../wpr-framework/mode/WprMultiMode';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';

/**
 * プランマルチモード
 */
export class PlanMultiMode extends WprBaseViewMultiModeInfo<PlanComponentView>{
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Type: WprControlInfo = null;
	@WprDI_Control
	private m_Yes: WprControlInfo = null;
	// @WprDI_Control
	// private m_OptionName: WprControlInfo = null;
	@WprDI_Control
	private m_Label5: WprControlInfo = null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() { super('planMultiMode'); }
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('初期');
		list.push('非表示');
		list.push('表示');
		list.push('表示_OTA');
		list.push('表示_DTP');
		// list.push('オプション名表示');
		// list.push('オプション名非表示');
		list.push('リーズナブル');
		list.push('スタンダード');
		list.push('プレミアム');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		// this.addControl('optionName',
		// 	{
		// 		value: [
		// 			{ mode: 'オプション名表示', value: 'オプション' },
		// 			{ mode: 'オプション名非表示', value: '' },]
		// 	}
		// );
		this.addControl('planName',
			{
				value: [
					{ mode: 'リーズナブル', value: 'リーズナブルプラン' },
					{ mode: 'スタンダード', value: 'スタンダードプラン' },
					{ mode: 'プレミアム', value: 'プレミアムプラン' },
					{ mode: 'other', value: '' },],
			}
		);
		this.addControl('addOption',
			{
				value: [
					{ mode: '表示', value: ' + ' }, { mode: '非表示', value: '' }
				]
			}
		);
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @param newMode 新しいモード
	 */
	public onCheckMultiMode(curMode: WprMultiMode, newMode: WprMultiMode): void {
		if (this.m_Type.value === '')
			newMode.addMode('初期');
		else if (this.m_Type.value === 'reasonable')
			newMode.addMode('リーズナブル');
		else if (this.m_Type.value === 'standard')
			newMode.addMode('スタンダード');
		else if (this.m_Type.value === 'premium')
			newMode.addMode('プレミアム');
		// if(this.m_Yes.value === true && this.getGlobalMode('product') === 'OTA')
		// 	newMode.addMode('オプション名表示');
		// else if(this.m_Yes.value === true && this.getGlobalMode('product') === 'DTP')
		// 	newMode.addMode('表示_DTP');
		// if (this.m_Yes.value !== true)
		// 	newMode.addMode('オプション名非表示');
		// else
			// newMode.addMode('オプション名表示');
		if (this.m_Type.value !== '' && this.m_Yes.value === true)
			newMode.addMode('表示');
		else
			newMode.addMode('非表示');
		// WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 START
		if (this.getGlobalMode('product') === 'OTA')
			newMode.addMode('表示_OTA');
		// WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 END
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		if (this.getGlobalMode('product') === 'DTP')
			newMode.addMode('表示_DTP');
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
	}
	// --------------------------------------------------------------------------
}